export const CONTENT_LAYOUT_X = {
  'Align left': 'ALIGN_LEFT',
  'Align center': 'ALIGN_CENTER',
};
